import { render, staticRenderFns } from "./AnnouncementBar.vue?vue&type=template&id=8d67b330&scoped=true"
import script from "./AnnouncementBar.vue?vue&type=script&lang=js"
export * from "./AnnouncementBar.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementBar.vue?vue&type=style&index=0&id=8d67b330&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d67b330",
  null
  
)

export default component.exports